import GetShopOrdersByDigitalAssetIdRequestModelBase from '../_generated/modelBases/get-shop-orders-by-digital-asset-id-request-model-base';

export default class GetShopOrdersByDigitalAssetIdRequestModel extends GetShopOrdersByDigitalAssetIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
